import React from "react";

const Applicability_of_new_TDS_forms = () => {
  return (
    <>
      {/* Forms mapping table */}
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr>
            <th style={styles.th}>Existing Forms</th>
            <th style={styles.th}>New Forms</th>
            <th style={styles.th}>Purpose of form</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={styles.td}>Form 24Q</td>
            <td style={styles.td}>Form no. 138</td>
            <td style={styles.td}>TDS Return - Salary</td>
          </tr>
          <tr>
            <td style={styles.td}>Form 26Q</td>
            <td style={styles.td}>Form no. 140</td>
            <td style={styles.td}>TDS Return - Non-salary payments</td>
          </tr>
          <tr>
            <td style={styles.td}>Form 27Q</td>
            <td style={styles.td}>Form no. 144</td>
            <td style={styles.td}>TDS for non-residents (other than salary)</td>
          </tr>
          <tr>
            <td style={styles.td}>Form 27EQ</td>
            <td style={styles.td}>Form no. 143</td>
            <td style={styles.td}>TCS Return (Tax Collected at Source)</td>
          </tr>
        </tbody>
      </table>

      {/* Applicability heading */}
      <h3 style={styles.heading}>Applicability</h3>

      {/* Applicability table */}
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr>
            <th style={styles.th}>Criteria</th>
            <th style={styles.th}>Existing Forms (IT Act, 1961)</th>
            <th style={styles.th}>New Forms (IT Act, 2025)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={styles.td}>Applicable Period</td>
            <td style={styles.td}>Financial Year (FY) 2025–26 & earlier</td>
            <td style={styles.td}>*Tax Year (TY) 2026–27 onwards</td>
          </tr>
          <tr>
            <td style={styles.td}>Transaction Date</td>
            <td style={styles.td}>On or before March 31, 2026</td>
            <td style={styles.td}>On or after April 1, 2026</td>
          </tr>
          <tr>
            <td style={styles.td}>Corrections</td>
            <td style={styles.td}>For corrections pertaining to periods up to March 31, 2026</td>
            <td style={styles.td}>For corrections pertaining to periods from April 1, 2026 onwards</td>
          </tr>
        </tbody>
      </table>

      {/* Footnote */}
      <p style={styles.footnote}>
        *"Financial Year" is now replaced with "Tax Year" under the Income Tax Act, 2025
      </p>
    </>
  );
};

// CSS styles for table
const styles = {
  th: {
    border: "1px solid white",
    padding: "8px",
    textAlign: "left",
  },
  td: {
    border: "1px solid white",
    padding: "8px",
    textAlign: "left",
  },
  heading: {
    marginTop: "20px",
    marginBottom: "10px",
  },
  footnote: {
    marginTop: "10px",
  },
};

export default Applicability_of_new_TDS_forms;